<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 text-center">
                <h2><i class="far fa-credit-card"></i>&nbsp;&nbsp;Card Setting</h2>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 text-center">
              <p>
                <span v-if="this.$global.paymentStatusFailed && !this.$global.systemUser">Your credit card failed. Please update</span>
                <span v-else>Update</span>
                the credit card on file for your account. Updating this card will replace your current payment method.
              </p>
            </div>
            <!-- <div class="col-sm-12 col-md-12 col-lg-12 text-center pt-2">
               <div style="display:inline-block">
                <a href="#" @click="modals.helpguide = true" style="display:inline-flex"><i class="far fa-play-circle" style="font-size:21px;padding-right:5px"></i> <span>here for more information.</span></a>
               </div>
            </div> -->
        </div>
        <div class="pt-2 pb-2">&nbsp;</div>
        
        <!-- SECTION 1: OUTSTANDING INVOICES (WEEKLY/MONTHLY) -->
        <div :class="isClient ? 'payment-alert-container--client' : 'payment-alert-container--agency'" v-if="hasWeeklyMonthlyFailed">
          <div class="payment-alert-card payment-alert-card--invoice">
            <div class="payment-alert-card__header" @click="toggleSection('weekly')">
              <i class="fas fa-exclamation-triangle payment-alert-card__icon"></i>
              <h4 class="payment-alert-card__title">Outstanding Invoices for Weekly/Monthly Campaigns</h4>
              <i class="fas payment-alert-card__chevron" :class="sectionsExpanded.weekly ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </div>
            <div class="payment-alert-card__body" v-show="sectionsExpanded.weekly">
              <p class="payment-alert-card__description">Your account has outstanding invoices for these campaigns:</p>
              <div class="payment-alert-card__list">
                <div class="payment-alert-card__item" v-for="(item, index) in failedCampaignNumber" :key="index">
                  <span class="payment-alert-card__campaign-label" v-if="item != 'minspend'">Campaign #{{ item }}</span>
                  <span class="payment-alert-card__campaign-label" v-else>Minimum Spend</span>
                  <span class="payment-alert-card__amount">{{ displayMoney(failedInvoiceAmount[index]) }}</span>
                </div>
              </div>
              <div class="payment-alert-card__total">
                <span class="payment-alert-card__total-label">Total Outstanding Amount:</span>
                <span class="payment-alert-card__total-value">{{ failedInvoiceTotal() }}</span>
              </div>
              <p class="payment-alert-card__message">Please update your credit card information or retry the charge with your existing card. Thank you.</p>
            </div>
          </div>
        </div>
        <!-- SECTION 1: OUTSTANDING INVOICES (WEEKLY/MONTHLY) -->

        <!-- SECTION 2: FAILED AUTO TOP-UP (PREPAID) -->
        <div :class="isClient ? 'payment-alert-container--client' : 'payment-alert-container--agency'" v-if="hasPrepaidFailed">
          <div class="payment-alert-card payment-alert-card--prepaid">
            <div class="payment-alert-card__header" @click="toggleSection('prepaid')">
              <i class="fas fa-pause-circle payment-alert-card__icon"></i>
              <h4 class="payment-alert-card__title">Failed Auto Top-up for Prepaid Campaigns</h4>
              <i class="fas payment-alert-card__chevron" :class="sectionsExpanded.prepaid ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </div>
            <div class="payment-alert-card__body" v-show="sectionsExpanded.prepaid">
              <p class="payment-alert-card__description">The following campaigns were paused due to failed auto top-up. Continuous top-up has been stopped for these campaigns:</p>
              <div class="payment-alert-card__list">
                <div class="payment-alert-card__item payment-alert-card__item--prepaid" v-for="(campaignId, index) in failedPrepaidCampaignIds" :key="index">
                  <span class="payment-alert-card__campaign-id">Campaign #{{ campaignId }}</span>
                </div>
              </div>
              <p class="payment-alert-card__message">Please update your credit card information to reactivate these campaigns and resume continuous top-up.</p>
            </div>
          </div>
        </div>
        <!-- SECTION 2: FAILED AUTO TOP-UP (PREPAID) -->

        <!-- START THE CARD CONTENT -->
        <div :class="showWholesaleCost ? 'row' : 'row justify-content-center centerform'">
        <!-- First Column: Billing Settings Form -->
        <div :class="showWholesaleCost ? 'col-sm-12 col-md-12 col-lg-6' : 'col-sm-12 col-md-12 col-lg-12'">
        <ValidationObserver ref="form">    
        <form id="usrccform">

        <div id="card-element" class="col-sm-12 col-md-12 col-lg-12 card-border">&nbsp;</div> <div class="pt-2 pl-2" v-if="cardfailetoload" style="font-size:0.80143rem"><i class="fas fa-sync-alt pr-2" @click="refreshCCfield();" style="cursor:pointer"></i>Failed to load the Credit Card field. Please <a href="javascript:void(0);" @click="refreshCCfield();" style="font-weight:bold">click here</a> to refresh and try again.</div>
        <div id="carderror" class="col-sm-12 col-md-12 col-lg-12 pt-2 hide" style="color:red"><small>&nbsp;</small></div>

        <div class="col-sm-12 col-md-12 col-lg-12">
          <ValidationProvider
            name="Card Holder Name"
            rules="required"
            v-slot="{ passed, failed, errors }"
          >
          <base-input
            v-model="cardholdername"
            label="Card Holder Name"
            :error="errors[0]"
            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
          </base-input>
         </ValidationProvider>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12">
          <ValidationProvider
            name="Billing Address"
            rules="required"
            v-slot="{ passed, failed, errors }"
          >
          <base-input
            v-model="billingaddress"
            label="Billing Address"
            :error="errors[0]"
            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
          </base-input>
         </ValidationProvider>
        </div>

                  <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                    <div class="country-region-select-wrapper">
                      <span  class="country-label">Country *</span>
                      <country-select  class="country-region-select"  v-model="selects.country" :country="selects.country" topCountry="US" />
                      <span v-if="showErrorMessage && !selects.country" style="color: #942434;">Please select country</span>
                    </div> 
                 </div>
                <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                  <div v-if="selects.country" class="country-region-select-wrapper">
                  <span class="country-label">{{selects.country === "CA" ?"Province *": "State *"}}</span>
                  <region-select  class="country-region-select" v-model="selects.state" :country="selects.country" :region="selects.state"  />
                  <span v-if="showErrorMessage && !selects.state" style="color: #942434;">Please select state</span>
                  </div>
                </div>
        <div class="row pt-2 mr-0 ml-0">
          <div class="col-sm-6 col-md-6 col-lg-6">
              <ValidationProvider
                name="City"
                rules="required"
                v-slot="{ passed, failed, errors }"
              
              >
                <base-input
                  v-model="city"
                  label="City"
                  :error="errors[0]"
                  :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                </base-input>
              </ValidationProvider>
          </div>
          <!-- <div class="col-sm-4 col-md-4 col-lg-4">
             <label>State</label>
             <base-input>
                <el-select
                  id="stateid"
                  v-model="selects.state"
                  class="select-primary "
                  name="state"
                  inline
                  size="large"
                  filterable
                  default-first-option
                  >
                  <el-option
                    v-for="option in selects.statelist"
                    class="select-primary"
                    :label="option.state"
                    :value="option.state_code"
                    :key="option.state_code"
                  ></el-option>
                </el-select>
             </base-input>
          </div> -->
          <div class="col-sm-6 col-md-6 col-lg-6">
            <ValidationProvider
                name="Zip"
                rules="required"
                v-slot="{ passed, failed, errors }"
              
              >
              <base-input
                  v-model="zipcode"
                  label="Zip"
                  :error="errors[0]"
                  :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                </base-input>
              </ValidationProvider>
          </div>
        </div>

         <div class="pt-3 pb-3">&nbsp;</div>

        <div class="col-sm-12 col-md-12 col-lg-12 ">
            <card>
                <div slot="header"><h4 class="card-title">Your Current Card Information</h4></div>
            </card>
        </div>

       
            <div class="col-sm-12 col-md-12 col-lg-12 mr-0 ml-0">
                <p class="text-title-wrapping" v-if="currCardHolder != ''">{{currCardHolder}}</p>
                <p v-if="currCardlastdigit != ''">Card Number : &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull; {{currCardlastdigit}}</p>
                <p v-if="currCardType != ''">Card Type : {{currCardType}}</p>
            </div>
        
        <div class="pt-3 pb-3">&nbsp;</div>
        
        <div class="col-sm-12 col-md-12 col-lg-12 ">
                <base-checkbox :disabled="agreeTermDisable" v-model="agreeTerm" class="pull-left" :class="{'has-danger': agreeTermStat}">I have read and agree to the <a href="#termofbilling" style="color:#919aa3;text-decoration:underline;font-weight:bold" :style="[agreeTermStat?{'color':'#ec250d'}:'']" v-on:click.stop.prevent="modals.termofbilling = true"> service and billing agreement</a></base-checkbox> 
        </div>
        <div class="pt-3 pb-3">&nbsp;</div>
        <div class="row pt-2" style="width:100%; display: flex; justify-content: flex-end; gap: 10px;" v-if="!hasWeeklyMonthlyFailed">
            <base-button v-if="currCardlastdigit != '' && currCardType != '' && this.$global.paymentStatusFailed" @click="clearPaymentStatusHandler();" id="btnClearPaymentStatus" size="sm"
                style="height:40px">
                Reactivate card
            </base-button>
            <base-button id="btnupdatecc" @click="validate('')" size="sm" style="height:40px">
                Update Card
            </base-button>
        </div>
        <div class="row pt-2" style="width:100%" v-if="hasWeeklyMonthlyFailed">
                                                    
            <div class="col-sm-6 col-md-6 col-lg-6 pl-4">
                <base-button @click="validate('existcard')" id="btnRetryExistCard" size="sm" class="pull-right" style="height:50px">
                Retry charge with existing card
                </base-button>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6 pr-0">
                <base-button @click="validate('updatecharge')" id="btnUpdateAndCharge" size="sm" class="pull-right" style="height:50px">
                save and charge amount due
                </base-button>
            </div>
        </div>

        </form>
        </ValidationObserver>
        </div>
        <!-- End First Column: Billing Settings Form -->
        
        <!-- Second Column: Wholesale Cost Section -->
        <div class="col-sm-12 col-md-12 col-lg-6" v-if="showWholesaleCost">
            <card>
                    <div slot="header">
                        <div class="d-flex justify-content-between align-items-center">
                            <h4 class="card-title mb-0">Your Wholesale Cost per Contact</h4>
                            <div class="pricing-duration-dropdown-wrapper" style="min-width: 150px;">
                                <el-select
                                    class="select-primary"
                                    size="small"
                                    placeholder="Select Frequency"
                                    v-model="selectedFrequency"
                                    >
                                    <el-option
                                        v-for="freq in availableFrequencies"
                                        class="select-primary"
                                        :value="freq"
                                        :label="freq"
                                        :key="freq"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div v-if="isLoadingWholesaleCost" class="text-center p-3">
                        <i class="fas fa-spinner fa-spin"></i> Loading...
                    </div>
                    <div v-else class="pt-3">
                        <div class="row">
                            <!-- First Column: Local and Locator -->
                            <div class="col-sm-12 col-md-6">
                                <!-- Local Module -->
                                <div v-if="defaultModule[0].name && Object.keys(wholesaleCostData.local).length > 0" class="mb-4">
                                    <h5 class="mb-3" :style="{ color: 'var(--text-primary-color)' }">
                                        <i class="far fa-eye mr-2"></i>
                                        <span v-if="this.$global.globalModulNameLink && this.$global.globalModulNameLink.local">
                                            {{ this.$global.globalModulNameLink.local.name }}
                                        </span>
                                        <span v-else>Local</span>
                                    </h5>
                                    <div v-for="(data, freq) in wholesaleCostData.local" :key="freq" 
                                         v-show="selectedFrequency === 'All' || selectedFrequency === freq"
                                         class="mb-3 pl-3" style="border-left: 3px solid #e0e0e0;">
                                        <h6 class="mb-2" :style="{ color: 'var(--text-primary-color)' }">{{ freq }}</h6>
                                        <!-- Wholesale Cost -->
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Cost per contact (basic): <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.costPerLead) }}</strong>
                                        </p>
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Cost per contact (advanced): <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.costPerLeadAdvanced) }}</strong>
                                        </p>
                                        <!-- Base Price -->
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Base price for Setup Fee: <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.platformFee) }}</strong>
                                        </p>
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Base price for Campaign Fee: <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.minCostMonth) }}</strong>
                                        </p>
                                    </div>
                                </div>
                                
                                <!-- Locator Module -->
                                <div v-if="defaultModule[1].name && Object.keys(wholesaleCostData.locator).length > 0" class="mb-4">
                                    <h5 class="mb-3" :style="{ color: 'var(--text-primary-color)' }">
                                        <i class="fas fa-map-marked mr-2"></i>
                                        <span v-if="this.$global.globalModulNameLink && this.$global.globalModulNameLink.locator">
                                            {{ this.$global.globalModulNameLink.locator.name }}
                                        </span>
                                        <span v-else>Locator</span>
                                    </h5>
                                    <div v-for="(data, freq) in wholesaleCostData.locator" :key="freq" 
                                         v-show="selectedFrequency === 'All' || selectedFrequency === freq"
                                         class="mb-3 pl-3" style="border-left: 3px solid #e0e0e0;">
                                        <h6 class="mb-2" :style="{ color: 'var(--text-primary-color)' }">{{ freq }}</h6>
                                        <!-- Wholesale Cost -->
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Cost per contact: <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.costPerLead) }}</strong>
                                        </p>
                                        <!-- Base Price -->
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Base price for Setup Fee: <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.platformFee) }}</strong>
                                        </p>
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Base price for Campaign Fee: <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.minCostMonth) }}</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Second Column: Enhance and B2B -->
                            <div class="col-sm-12 col-md-6">
                                <!-- Enhance Module -->
                                <div v-if="this.$global.globalModulNameLink.enhance.name !== null && this.$global.globalModulNameLink.enhance.url != null && defaultModule[2].name && Object.keys(wholesaleCostData.enhance).length > 0" class="mb-4">
                                    <h5 class="mb-3" :style="{ color: 'var(--text-primary-color)' }">
                                        <i class="fa-solid fa-angles-up mr-2"></i>
                                        <span v-if="this.$global.globalModulNameLink && this.$global.globalModulNameLink.enhance && this.$global.globalModulNameLink.enhance.name">
                                            {{ this.$global.globalModulNameLink.enhance.name }}
                                        </span>
                                        <span v-else>Enhance</span>
                                    </h5>
                                    <div v-for="(data, freq) in wholesaleCostData.enhance" :key="freq" 
                                         v-show="selectedFrequency === 'All' || selectedFrequency === freq"
                                         class="mb-3 pl-3" style="border-left: 3px solid #e0e0e0;">
                                        <h6 class="mb-2" :style="{ color: 'var(--text-primary-color)' }">{{ freq }}</h6>
                                        <!-- Wholesale Cost -->
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Cost per contact (minimum): <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.costPerLead) }}</strong> 
                                            or 50% of retail price
                                        </p>
                                        <!-- Base Price -->
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Base price for Setup Fee: <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.platformFee) }}</strong>
                                        </p>
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Base price for Campaign Fee: <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.minCostMonth) }}</strong>
                                        </p>
                                    </div>
                                </div>
                                
                                <!-- B2B Module -->
                                <div v-if="this.$global.globalModulNameLink.b2b.name !== null && this.$global.globalModulNameLink.b2b.url != null && defaultModule[3].name && validateBetaFeature('b2b_module') && Object.keys(wholesaleCostData.b2b).length > 0" class="mb-4">
                                    <h5 class="mb-3" :style="{ color: 'var(--text-primary-color)' }">
                                        <i class="fa-solid fa-building mr-2"></i>
                                        <span v-if="this.$global.globalModulNameLink && this.$global.globalModulNameLink.b2b && this.$global.globalModulNameLink.b2b.name">
                                            {{ this.$global.globalModulNameLink.b2b.name }}
                                        </span>
                                        <span v-else>B2B</span>
                                    </h5>
                                    <div v-for="(data, freq) in wholesaleCostData.b2b" :key="freq" 
                                         v-show="selectedFrequency === 'All' || selectedFrequency === freq"
                                         class="mb-3 pl-3" style="border-left: 3px solid #e0e0e0;">
                                        <h6 class="mb-2" :style="{ color: 'var(--text-primary-color)' }">{{ freq }}</h6>
                                        <!-- Wholesale Cost -->
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Cost per contact (minimum): <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.costPerLead) }}</strong> 
                                            or 50% of retail price
                                        </p>
                                        <!-- Base Price -->
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Base price for Setup Fee: <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.platformFee) }}</strong>
                                        </p>
                                        <p class="mb-1 small" :style="{ color: 'var(--accent-color)' }">
                                            Base price for Campaign Fee: <strong :style="{ color: 'var(--text-primary-color)' }">{{ formatPrice(data.minCostMonth) }}</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div v-if="Object.keys(wholesaleCostData.local).length === 0 && 
                                   Object.keys(wholesaleCostData.locator).length === 0 && 
                                   Object.keys(wholesaleCostData.enhance).length === 0 && 
                                   Object.keys(wholesaleCostData.b2b).length === 0" 
                             class="text-center p-3" :style="{ color: 'var(--accent-color)' }">
                            No wholesale cost information available.
                        </div>
                    </div>
                </card>
                
                <!-- Subscription Pricing Section -->
                <card v-if="subscriptionModules.length > 0" class="mt-4">
                    <div slot="header">
                        <h4 class="card-title mb-0">Subscription Pricing</h4>
                    </div>
                    <div class="pt-3">
                        <p class="mb-3" :style="{ color: 'var(--text-primary-color)' }">
                            The following pricing, usage allocations, and terms apply to Module subscriptions activated through this platform. 
                            By subscribing to a Module, you agree to these terms as part of your Master Services Agreement with Exact Match Marketing.
                        </p>
                        <p class="mb-3" :style="{ color: 'var(--text-primary-color)' }">
                            All Module subscriptions require a 12-month commitment and are billed monthly in advance. 
                            Unused monthly allocation does not roll over. Pricing displayed below is effective as of 
                            <strong>{{ subscriptionEffectiveDate }}</strong> and is subject to change for future subscription terms 
                            in accordance with your Master Services Agreement.
                        </p>

                        <div class="table-responsive">
                            <table class="table table-bordered" :style="{ color: 'var(--text-primary-color)' }">
                                <thead>
                                    <tr>
                                        <th>Module</th>
                                        <th>Monthly Fee</th>
                                        <th>Monthly Allocation</th>
                                        <th>Overage Billing</th>
                                        <th>Overage Rate (if enabled)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="module in subscriptionModules" :key="module.name">
                                        <td><strong>{{ module.name }}</strong></td>
                                        <td>{{ formatPrice(module.monthlyFee) }}</td>
                                        <td>{{ module.monthlyAllocation }}</td>
                                        <td>
                                            <span v-if="module.overageEnabled" class="d-inline-flex align-items-center">
                                                <i class="fas fa-check-circle text-success mr-1"></i> Enabled
                                            </span>
                                            <span v-else class="d-inline-flex align-items-center">
                                                <i class="fas fa-times-circle text-danger mr-1"></i> Disabled
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="module.overageEnabled">
                                                {{ formatPrice(module.overageRate) }} {{ module.overageUnit }}
                                            </span>
                                            <span v-else>-</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div class="mt-3">
                            <p class="mb-0 small" :style="{ color: 'var(--accent-color)' }">
                                <span v-if="overageBillingEnabled">
                                    If overage billing is enabled, usage exceeding your monthly allocation will be billed at the overage rate shown above.
                                </span>
                                <span v-else>
                                    If disabled, your usage will be capped at your monthly allocation.
                                </span>
                            </p>
                        </div>
                        
                        <div class="mt-3 pt-3 subscription-terms-note">
                            <p class="mb-0 small" :style="{ color: 'var(--accent-color)' }">
                                A record of your Subscription Terms at the time of activation will be retained and available for your review in your account settings.
                            </p>
                        </div>
                    </div>
                </card>
                <!-- End Subscription Pricing Section -->
        </div>
        <!-- End Second Column: Wholesale Cost Section -->
        </div>
        
        <!-- START THE CARD CONTENT -->
       
       <!-- Card Update Modal -->
            <modal :show.sync="modals.cardupdate" headerClasses="justify-content-center">
              <h4 slot="header" class="title title-up">Card Information</h4>
              <p>
                Thank you! Your Credit Card Information Has been updated.
              </p>
              <template slot="footer">
                <div class="container text-center pb-4">
                  <base-button  @click.native="modals.cardupdate = false">Ok</base-button>
                </div>
              </template>
            </modal>
       <!-- Card Update Modal -->
       <!-- Card retry charge Modal -->
            <modal :show.sync="modals.cardretrycharge" headerClasses="justify-content-center">
                <h4 slot="header" class="title title-up">{{cardretrychargeTitle}}</h4>
                <p class="text-center"  v-html="cardretrychargeTxt">
                   
                </p>
                <template slot="footer">
                    <div class="container text-center pb-4">
                    <base-button  @click.native="closebtnupdatecard()">Ok</base-button>
                    </div>
                </template>
            </modal>
       <!-- Card retry charge Modal -->    

       <!-- MODAL TERM OF BILLING-->
        <modal :show.sync="modals.termofbilling" headerClasses="justify-content-center" id="modaltermofbilling">
              <div>
                <iframe src="/service-billing-agreement" width="100%"  height="400vh"/>
              </div>
              <template slot="footer">
                <div class="container text-center pb-4">
                  <base-button @click="agreedtermofbilling();">Yes, I Understand</base-button>
                </div>
                <div class="container text-center pb-4">
                 <a href="/service-billing-agreement" @click.prevent="$router.push('/service-billing-agreement')">Click here for service and billing agreement page</a>  
                </div>
              </template>
        </modal>
      <!--MODAL TERM OF BILLING -->
        
    </div>
</template>

<script>
import { Select, Option } from 'element-ui';
import { Modal,BaseCheckbox } from '/src/components';
import swal from 'sweetalert2';
import { DOCUMENTS } from '../../../../shared/constants'

var _elements;
var _cardElement;
var _stripe;
var _CardValidate;
var _tokenid = '';
var _sppubkey = '';
var _this;

export default {
    components: {
        Modal,
        BaseCheckbox,
        [Option.name]: Option,
        [Select.name]: Select,
    },
    data() {
        return {
            currCardHolder: '',
            showErrorMessage: false,
            cardfailetoload:false,
            currCardlastdigit: '',
            currCardType: '',

            cardholdername: '',
            billingaddress: '',
            city: '',
            zipcode: '',
            selects: {
                state: '',
                country: '',
                statelist: [],
            },
            agreeTermDisable:false,
            agreeTermBilling:false,
            agreeTermStatBilling:false,
            agreeTerm:false,
            agreeTermStat:false,

            modals: {
                cardupdate: false,
                termofbilling: false,
                cardretrycharge: false,
            },

            cardretrychargeTitle: '',
            cardretrychargeTxt: '',

            clientPaymentFailed: false,
            agencyPaymentFailed: false,
            failedCampaignNumber: [],
            failedInvoiceAmount: [],
            failedTotalOutstanding:0,
            failedPrepaidCampaignIds: [],
            isMinSpendV2: false,
            isMinSpendV3: false,
            isMinSpendV4: false,

                        
            // Wholesale Cost Data
            rootCostAgency: {},
            defaultBillingFrequency: 'Weekly',
            isLoadingWholesaleCost: false,
            selectedFrequency: 'Prepaid', // Default to 'Prepaid'
            availableFrequencies: [], // List of available frequencies
            
            // Data structure to store all frequencies per module
            wholesaleCostData: {
                local: {},
                locator: {},
                enhance: {},
                b2b: {}
            },
            
            // Subscription Pricing Data
            subscriptionModules: [],
            subscriptionEffectiveDate: '',
            overageBillingEnabled: false,
            
            // Default Module Data (for module visibility)
            defaultModule: [
                {
                    type: 'local',
                    name: '',
                    status: true,
                    icon: 'far fa-eye'
                },
                {
                    type: 'locator',
                    name: '',
                    status: true,
                    icon: 'fas fa-map-marked'
                },
                {
                    type: 'enhance',
                    name: '',
                    status: true,
                    icon: 'fa-solid fa-angles-up'
                },
                {
                    type: 'b2b',
                    name: '',
                    status: true,
                    icon: 'fa-solid fa-building'
                },
                {
                    type: 'simplifi',
                    name: '',
                    status: true,
                    icon: 'fa-solid fa-building'
                },
            ],

            sectionsExpanded: {
                weekly: true,
                prepaid: true
            }
        };
    },
    methods: {
      refreshCCfield() {
        if (this.$global.sppubkey != "") {
          _sppubkey = this.$global.sppubkey;
          this.initstripelib();
          //this.cardfailetoload = false;
        }else{
          this.$store.dispatch('getGeneralSetting', {
                companyID: this.user.company_root_id,
                settingname: 'rootstripe',
            }).then(response => {
              _sppubkey = response.data;
              this.initstripelib();
              //this.cardfailetoload = false;
            },error => {
              this.$notify({
                type: 'primary',
                message: 'Please try to refresh the page',
                icon: 'fas fa-bug'
              })
              this.cardfailetoload = true;    

            });
        }
      },
        displayMoney(val) {
          return this.$global.formatMoney(parseFloat(val));
        },
        failedInvoiceTotal() {
            // Calculate the total of the array items
            this.failedTotalOutstanding = this.failedInvoiceAmount.reduce((acc, val) => acc + parseFloat(val), 0);
            return this.$global.formatMoney(this.failedTotalOutstanding);
        },
        toggleSection(section) {
            this.sectionsExpanded[section] = !this.sectionsExpanded[section];
        },
        agreedtermofbilling() {
          this.agreeTerm = true;
          this.agreeTermDisable = false;
          this.modals.termofbilling = false;
        },
        processUpdateCard(action) {
            var _store = this.$store;
            var _this = this;
            const userData = this.$store.getters.userData;
            var _act = action;

            return new Promise((resolve, reject) => {
              _stripe.createToken(_cardElement).then(function(result) {
                  if(result.error) {
                      $('#btnupdatecc').html('Update Card');
                      $('#btnupdatecc').attr('disabled',false);
                      $('#btnUpdateAndCharge').html('save and charge amount due');
                      $('#btnUpdateAndCharge').attr('disabled',false);
                      $('#btnRetryExistCard').html('Retry charge with existing card');
                      $('#btnRetryExistCard').attr('disabled', false);
                      $('#carderror').html('<small style="color:red"><sup>*</sup>' + result.error.message + '</small>');
                      $('#carderror').show();
                  }else{
                      $('#carderror').hide();
                      _tokenid = result.token.id;
                      _store.dispatch('processUpdateCard', {
                          tokenid: _tokenid,
                          cardholder: _this.cardholdername,
                          address: _this.billingaddress,
                          city: _this.city,
                          state: _this.selects.state,
                          country: _this.selects.country,
                          zip: _this.zipcode,
                          usrID: userData.id,
                          companyParentID:  userData.company_parent,
                          action: _act,
                          document_type: _this.checkDocumentUrl(),
                          ip_user: userData.ip_login,
                          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                      }).then(response => {
                          if(response.result == 'success' && response.msg != '') {
                            $('#btnupdatecc').html('Update Card');
                            $('#btnupdatecc').attr('disabled',false);
                            $('#btnUpdateAndCharge').html('save and charge amount due');
                            $('#btnUpdateAndCharge').attr('disabled',false);
                            $('#btnRetryExistCard').html('Retry charge with existing card');
                            $('#btnRetryExistCard').attr('disabled', false);
                            $('#btnClearPaymentStatus').attr('disabled', false);
                            _this.$store.dispatch('retrieveUserData',{
                              usrID: userData.id,
                            }).then(() => {
                                _this.updatePaymentStatusFailed();
                            });
                            if (action == "updatecharge") {
                              swal.fire({
                                icon: "success",
                                title: response.title,
                                text: response.msg
                              }).then((result) => {
                                if (result.isConfirmed) {
                                    // Refresh the page when the user clicks "OK"
                                    location.reload();
                                }
                              });
                            }else{
                              swal.fire({
                                icon: "success",
                                title: response.title,
                                text: response.msg
                              });
                            }
                            _this.getCardInfo();
                            _this.cleanform();
                            _this.$refs.form.reset();  
                            _this.modals.cardupdate = false;
                            _this.modals.cardretrycharge = false;                    
                            _this.$global.agencyPaymentFailed = false;
                          }else{
                            $('#btnupdatecc').html('Update Card');
                            $('#btnupdatecc').attr('disabled',false);
                            $('#btnUpdateAndCharge').html('save and charge amount due');
                            $('#btnUpdateAndCharge').attr('disabled',false);
                            $('#btnRetryExistCard').html('Retry charge with existing card');
                            $('#btnRetryExistCard').attr('disabled', false);
                            $('#btnClearPaymentStatus').attr('disabled', false);
                            
                            _this.$store.dispatch('retrieveUserData',{
                              usrID: userData.id,
                            }).then(() => {
                                _this.updatePaymentStatusFailed();
                            });
                            swal.fire({
                              icon: "error",
                              title: response.title,
                              text: response.msg
                            });
                            _this.getCardInfo();
                            _this.cleanform();
                            _this.$refs.form.reset();  
                            _this.modals.cardupdate = false;
                            // _this.cardretrychargeTitle = response.title;
                            // _this.cardretrychargeTxt = response.msg;
                            // _this.modals.cardretrycharge = true;             
                          }
                      },error => {
                          
                      });
                  }
              });
            });
        },
        cleanform() {
          this.cardholdername = '';
          this.billingaddress = '';
          this.city = '';
          this.selects.state = '';
          this.zipcode = '';
          this.agreeTerm = false;
          this.agreeTermStat = false;
          _cardElement.clear();
        },
        closebtnupdatecard() {
            window.location.reload();
        },
        processRechargeExisting(_act) {
          const userData = this.$store.getters.userData;
          this.$store.dispatch('processUpdateCard', {
              tokenid: '',
              cardholder: '',
              address: '',
              city: '',
              state: '',
              country: '',
              zip: '',
              usrID: userData.id,
              companyParentID:  userData.company_parent,
              action: _act,
              document_type: _this.checkDocumentUrl(),
              ip_user: userData.ip_login,
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          }).then(response => {
            if(response.result == 'success' && response.msg != '') {
                            $('#btnRetryExistCard').html('Retry charge with existing card');
                            $('#btnRetryExistCard').attr('disabled',false);
                            $('#btnUpdateAndCharge').html('save and charge amount due');
                            $('#btnUpdateAndCharge').attr('disabled', false);
                            $('#btnClearPaymentStatus').attr('disabled', false);
                            $('#btnupdatecc').attr('disabled', false);

                            this.$store.dispatch('retrieveUserData',{
                              usrID: userData.id,
                            }).then(() => {
                                this.updatePaymentStatusFailed();
                            });
                            swal.fire({
                              icon: "success",
                              title: response.title,
                              text: response.msg
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    // Refresh the page when the user clicks "OK"
                                    location.reload();
                                }
                            });
                            this.getCardInfo();
                            this.cleanform();
                            this.$refs.form.reset();  
                            this.modals.cardupdate = false;
                            this.modals.cardretrycharge = false;                    
                          }else{
                            $('#btnRetryExistCard').html('Retry charge with existing card');
                            $('#btnRetryExistCard').attr('disabled',false);
                            $('#btnUpdateAndCharge').html('save and charge amount due');
                            $('#btnUpdateAndCharge').attr('disabled', false);
                            $('#btnClearPaymentStatus').attr('disabled', false);
                            $('#btnupdatecc').attr('disabled', false);

                            this.$store.dispatch('retrieveUserData',{
                              usrID: userData.id,
                            }).then(() => {
                                this.updatePaymentStatusFailed();
                            });
                            swal.fire({
                              icon: "error",
                              title: response.title,
                              text: response.msg
                            });
                            this.getCardInfo();
                            //this.cleanform();
                            this.$refs.form.reset();  
                            this.modals.cardupdate = false;
                            // _this.cardretrychargeTitle = response.title;
                            // _this.cardretrychargeTxt = response.msg;
                            // _this.modals.cardretrycharge = true;             
                }
          },error => {
              
          });
        },
        clearPaymentStatusHandler() {
            const userData = this.$store.getters.userData;
            const _this = this;
            
            // Show confirmation dialog
            swal.fire({
                title: "Reactivate existing card",
                text: "This action does not charge your card now. It only sets this card as active for upcoming payments.",
                showCancelButton: true,
                confirmButtonText: "Reactivate",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33"
            }).then((result) => {
                if (result.isConfirmed) {
                    $('#btnClearPaymentStatus').html('Processing...');
                    $('#btnClearPaymentStatus').attr('disabled', true);
                    $('#btnRetryExistCard').attr('disabled', true);
                    $('#btnUpdateAndCharge').attr('disabled', true);
                    $('#btnupdatecc').attr('disabled', true);

                    _this.$store.dispatch('clearPaymentStatus', {
                        usrID: userData.id,
                        companyParentID: userData.company_parent,
                    }).then(response => {
                            $('#btnClearPaymentStatus').html('Reactivate card');
                            $('#btnClearPaymentStatus').attr('disabled', false);
                            $('#btnRetryExistCard').attr('disabled', false);
                            $('#btnUpdateAndCharge').attr('disabled', false);
                            $('#btnupdatecc').attr('disabled', false);

                            if(response.result == 'success' && response.msg != '') {
                                _this.$store.dispatch('retrieveUserData', {
                                    usrID: userData.id,
                                }).then(() => {
                                    _this.updatePaymentStatusFailed();
                                });
                                
                                swal.fire({
                                    icon: "success",
                                    title: response.title,
                                    text: response.msg
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        // Refresh the page when the user clicks "OK"
                                        location.reload();
                                    }
                                });
                            } else {
                                swal.fire({
                                    icon: "error",
                                    title: response.title || 'Error',
                                    text: response.msg || 'Failed to clear payment status'
                                });
                            }
                        }).catch(error => {
                            $('#btnClearPaymentStatus').html('Reactivate card');
                            $('#btnClearPaymentStatus').attr('disabled', false);
                            $('#btnRetryExistCard').attr('disabled', false);
                            $('#btnUpdateAndCharge').attr('disabled', false);
                            $('#btnupdatecc').attr('disabled', false);

                            swal.fire({
                                icon: "error",
                                title: "Error",
                                text: "Failed to clear payment status. Please try again."
                            });
                        });
                }
            });
        },
        validate(action) {
          if (action == 'existcard') {
            $('#btnRetryExistCard').html('Processing...')
            $('#btnRetryExistCard').attr('disabled', true);
            $('#btnUpdateAndCharge').attr('disabled', true);
            $('#btnClearPaymentStatus').attr('disabled', true);
            $('#btnupdatecc').attr('disabled', true);
            
            /** UPDATE THE CARD INFORMATION */
            this.processRechargeExisting(action);
            /** UPDATE THE CARD INFORMATION */
            return false;
          }

          if (this.selects.country == '') {
              this.$notify({
                type: 'primary',
                message: 'Please select country',
                icon: 'fas fa-bug'
              })
              this.showErrorMessage = true;
            }
            if (this.selects.state == '') {
              this.$notify({
                type: 'primary',
                message: 'Please select state',
                icon: 'fas fa-bug'
              })
              this.showErrorMessage = true;
              // $('#usrccform #stateid').siblings().find('.el-select__caret.el-input__icon').addClass('has-danger');
              // $('#usrccform #stateid').siblings().find('.el-select__caret.el-input__icon').removeClass('has-success');
            } else {
              $('#usrccform #stateid').siblings().find('.el-select__caret.el-input__icon').removeClass('has-danger');
              $('#usrccform #stateid').siblings().find('.el-select__caret.el-input__icon').addClass('has-success');
            }

            this.agreeTermStat = false;
            if (this.agreeTerm == false) {
              this.agreeTermStat = true;
            }

            return this.$refs.form.validate().then(res => {
              if (res) {
                this.agreeTermStat = false;
                if (this.agreeTerm == false) {
                  this.agreeTermStat = true;
                
                  return false;
                }

                if (this.selects.state != '' && this.selects.country != '') {
                  $('#btnupdatecc').html('Processing...')
                  $('#btnupdatecc').attr('disabled', true);
                  $('#btnUpdateAndCharge').html('Processing...');
                  $('#btnUpdateAndCharge').attr('disabled', true);
                  $('#btnRetryExistCard').attr('disabled', true);
                  $('#btnClearPaymentStatus').attr('disabled', true);
                  /** UPDATE THE CARD INFORMATION */
                  this.processUpdateCard(action);
                  /** UPDATE THE CARD INFORMATION */
                }else{
                  this.showErrorMessage = true;
                }

              }
      });

    },
        initstripelib() {
            var chkload = this.$global.stripescriptload;
            if (chkload === false) {
                this.$global.initStripeScriptLoad(true);
                $.getScript( "https://js.stripe.com/v3/" )
                .done(function( script, textStatus ) {
                    initcreditcard();
                })
                .fail(function( jqxhr, settings, exception ) {
                    //$( "div.log" ).text( "Triggered ajaxError handler." );
                });
            }else{
              initcreditcard();
            }
        
        },

        getStateList() {
            this.$store.dispatch('getStateList').then(response => {
                this.selects.statelist = response.params
            },error => {
                
            });
        },

        getCardInfo() {
            const userData = this.$store.getters.userData;
             this.$store.dispatch('getCardInfo', {
                    usrID: userData.id,
            }).then(response => {
               //console.log(response.params);
               this.currCardHolder = (response.params.name != null)?response.params.name:''
               this.currCardlastdigit = (response.params.last4 != null)?response.params.last4:''
               this.currCardType = (response.params.brand != null)?response.params.brand:''
            },error => {
                
            });
        },
        checkDocumentUrl(){
          const userData = this.$store.getters.userData;
          if(this.$global.rootminspendsetting && this.$global.rootminspendsetting.status && this.isMinSpendV4){
            return DOCUMENTS.MINIMUM_SPEND_V4;
          } else if(this.$global.rootminspendsetting && this.$global.rootminspendsetting.status && this.isMinSpendV3){
            return DOCUMENTS.MINIMUM_SPEND_V3;
          } else if (this.$global.rootminspendsetting && this.$global.rootminspendsetting.status && this.isMinSpendV2){
            return DOCUMENTS.MINIMUM_SPEND_V2;
          } else if (this.$global.rootminspendsetting && this.$global.rootminspendsetting.status){
            return DOCUMENTS.MINIMUM_SPEND;
          } else if (userData.user_type != 'client'){
            return DOCUMENTS.DEFAULT_AGENCY;
          } else if (userData.user_type == 'client'){
            return DOCUMENTS.DEFAULT_CLIENT;
          } else {
            return ''
          }
        },
        checkMinSpendLatest(){
            const userData = this.$store.getters.userData

            this.$store.dispatch('getMinSpendLatest', {
              company_id: userData.company_id || '',
            }).then(response => {
                this.isMinSpendV2 = response.isAgreementV2
                this.isMinSpendV3 = response.isAgreementV3
                this.isMinSpendV4 = response.isAgreementV4
            },error => {
                console.log(error);
            });
        },
        updatePaymentStatusFailed() {
            const userData = this.$store.getters.userData;
            const userType = userData.user_type;
            
            // For client, use checkUserSetupComplete
            if (userType === 'client') {
                this.$store.dispatch('checkUserSetupComplete', {
                    usrID: userData.id,
                }).then(response => {
                    if (response && typeof response.paymentStatusFailed !== 'undefined') {
                        this.$global.paymentStatusFailed = response.paymentStatusFailed;
                        this.$global.failedPrepaidCampaignIds = response.fprepaidcampid || [];
                        this.failedPrepaidCampaignIds = this.$global.failedPrepaidCampaignIds;
                    }
                }).catch(error => {
                    console.log('Error updating paymentStatusFailed:', error);
                });
            } 
            // For agency/user, use GetRoleList
            else if (userType === 'userdownline' || userType === 'user') {
                const companyID = userData.company_id;
                const roleID = userData.role_id;
                
                this.$store.dispatch('GetRoleList', {
                    companyID: companyID,
                    getType: 'getrolemodule',
                    roleID: roleID,
                    usrID: userData.id,
                }).then(response => {
                    if (response && typeof response.paymentStatusFailed !== 'undefined') {
                        this.$global.paymentStatusFailed = response.paymentStatusFailed;
                        this.$global.failedPrepaidCampaignIds = response.fprepaidcampid || [];
                        this.failedPrepaidCampaignIds = this.$global.failedPrepaidCampaignIds;
                    }
                }).catch(error => {
                    console.log('Error updating paymentStatusFailed:', error);
                });
            }
        },
        getWholesaleCost() {
            // Skip if client
            if (!this.showWholesaleCost) {
                return;
            }
            
            const userData = this.$store.getters.userData;
            this.isLoadingWholesaleCost = true;
            
            // Determine setting name based on user type
            const settingName = this.$global.systemUser ? 'rootcostagency' : 'agencydefaultprice';
            const companyID = this.$global.systemUser 
                ? userData.company_root_id 
                : userData.company_id;
            
            this.$store.dispatch('getGeneralSetting', {
                companyID: companyID,
                settingname: settingName,
                idSys: this.$global.idsys
            }).then(response => {
                if (response.rootcostagency && response.rootcostagency != '') {
                    this.rootCostAgency = response.rootcostagency;
                    
                    // Extract all available frequencies
                    this.extractWholesaleCost();
                    
                    // Set default frequency to 'Prepaid' if available, otherwise use the first one or 'All'
                    if (this.availableFrequencies.length > 0) {
                        // Priority: Prepaid > frequency from response > All
                        if (this.availableFrequencies.includes('Prepaid')) {
                            this.selectedFrequency = 'Prepaid';
                        } else {
                            const defaultFreq = response.dpay || this.defaultBillingFrequency;
                            if (this.availableFrequencies.includes(defaultFreq)) {
                                this.selectedFrequency = defaultFreq;
                            } else {
                                // Use the first available frequency (after 'All')
                                const firstFreq = this.availableFrequencies.find(f => f !== 'All') || 'All';
                                this.selectedFrequency = firstFreq;
                            }
                        }
                    }
                }
                this.isLoadingWholesaleCost = false;
            }).catch(error => {
                console.log('Error loading wholesale cost:', error);
                this.isLoadingWholesaleCost = false;
            });
        },
        extractWholesaleCost() {
            // Reset data
            this.wholesaleCostData = {
                local: {},
                locator: {},
                enhance: {},
                b2b: {}
            };
            
            // Get allowed frequencies from rootpaymentterm (same as GeneralSetting.vue)
            const paymentTerms = this.$global.rootpaymentterm || [];
            const allowedFrequencies = paymentTerms.map(term => term.value); // e.g., ['Weekly', 'Monthly', 'Prepaid']
            
            // Map frequency names to match data structure (OneTime vs 'One Time')
            const frequencyMap = {
                'Weekly': 'Weekly',
                'Monthly': 'Monthly',
                'Prepaid': 'Prepaid',
                'One Time': 'OneTime' // Map 'One Time' to 'OneTime' for data lookup
            };
            
            const foundFrequencies = new Set();
            
            // Extract for Local - only frequencies that exist in rootpaymentterm
            if (this.rootCostAgency.local) {
                allowedFrequencies.forEach(termValue => {
                    const freq = frequencyMap[termValue] || termValue;
                    if (this.rootCostAgency.local[freq]) {
                        foundFrequencies.add(termValue); // Use original term value for display
                        // Use termValue as key to match selectedFrequency
                        this.$set(this.wholesaleCostData.local, termValue, {
                            costPerLead: this.rootCostAgency.local[freq].LeadspeekCostperlead || 0,
                            costPerLeadAdvanced: this.rootCostAgency.local[freq].LeadspeekCostperleadAdvanced || 0,
                            platformFee: this.rootCostAgency.local[freq].LeadspeekPlatformFee || 0,
                            minCostMonth: this.rootCostAgency.local[freq].LeadspeekMinCostMonth || 0
                        });
                    }
                });
            }
            
            // Extract for Locator - only frequencies that exist in rootpaymentterm
            if (this.rootCostAgency.locator) {
                allowedFrequencies.forEach(termValue => {
                    const freq = frequencyMap[termValue] || termValue;
                    if (this.rootCostAgency.locator[freq]) {
                        foundFrequencies.add(termValue);
                        // Use termValue as key to match selectedFrequency
                        this.$set(this.wholesaleCostData.locator, termValue, {
                            costPerLead: this.rootCostAgency.locator[freq].LocatorCostperlead || 0,
                            platformFee: this.rootCostAgency.locator[freq].LocatorPlatformFee || 0,
                            minCostMonth: this.rootCostAgency.locator[freq].LocatorMinCostMonth || 0
                        });
                    }
                });
            }
            
            // Extract for Enhance - only frequencies that exist in rootpaymentterm
            if (this.rootCostAgency.enhance) {
                allowedFrequencies.forEach(termValue => {
                    const freq = frequencyMap[termValue] || termValue;
                    if (this.rootCostAgency.enhance[freq]) {
                        foundFrequencies.add(termValue);
                        // Use termValue as key to match selectedFrequency
                        this.$set(this.wholesaleCostData.enhance, termValue, {
                            costPerLead: this.rootCostAgency.enhance[freq].EnhanceCostperlead || 0,
                            platformFee: this.rootCostAgency.enhance[freq].EnhancePlatformFee || 0,
                            minCostMonth: this.rootCostAgency.enhance[freq].EnhanceMinCostMonth || 0
                        });
                    }
                });
            }
            
            // Extract for B2B - only frequencies that exist in rootpaymentterm
            if (this.rootCostAgency.b2b) {
                allowedFrequencies.forEach(termValue => {
                    const freq = frequencyMap[termValue] || termValue;
                    if (this.rootCostAgency.b2b[freq]) {
                        foundFrequencies.add(termValue);
                        // Use termValue as key to match selectedFrequency
                        this.$set(this.wholesaleCostData.b2b, termValue, {
                            costPerLead: this.rootCostAgency.b2b[freq].B2bCostperlead || 0,
                            platformFee: this.rootCostAgency.b2b[freq].B2bPlatformFee || 0,
                            minCostMonth: this.rootCostAgency.b2b[freq].B2bMinCostMonth || 0
                        });
                    }
                });
            }
            
            // Set available frequencies - only those that exist in rootpaymentterm
            this.availableFrequencies = ['All', ...Array.from(foundFrequencies).sort()];
        },
        formatPrice(price) {
            // Helper to format price (similar to GeneralSetting.vue)
            return this.$global.formatMoney(parseFloat(price || 0));
        },
        validateBetaFeature(type) {
            // Validate beta feature access (same logic as GeneralSetting.vue)
            if(['b2b','b2b_module'].includes(type) && !this.$global.systemUser) {
                if(!this.$global.betaFeature.b2b_module.is_beta || this.$global.betaFeature.b2b_module.apply_to_all_agency || this.$global.isBeta) {
                    return true;
                } else {
                    return false;
                }
            } else if (['simplifi','simplifi_module'].includes(type) && !this.$global.systemUser) {
                if (!this.$global.betaFeature.simplifi_module.is_beta || this.$global.betaFeature.simplifi_module.apply_to_all_agency || this.$global.isBeta) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        },
        async getSubscriptionPricing() {
          const today = new Date();
          this.subscriptionEffectiveDate = today.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          });
            
          // variable
          this.subscriptionModules = [];
          const userData = this.$store.getters.userData;
          
          try {
            // Get feature IDs untuk predict dan clean
            const predictFeatureId = this.$global.betaFeature.predict_module.id;
            const cleanFeatureId = this.$global.betaFeature.clean_module.id;
            const audienceFeatureId = this.$global.betaFeature.audience_module.id;
            
            // Collect feature IDs yang akan di-check
            const featureIds = [];
            if (predictFeatureId) featureIds.push(predictFeatureId);
            if (cleanFeatureId) featureIds.push(cleanFeatureId);
            if (audienceFeatureId) featureIds.push(audienceFeatureId);

            if (featureIds.length > 0) {
              // Call API untuk check agreement status untuk multiple features sekaligus
              const response = await this.$store.dispatch('getMarketingServicesAgreementFeatureMulti', {
                user_id: userData.id,
                feature_ids: featureIds
              });
              
              // Get agreement status dari response data
              const agreementsData = response.data || {};
              
              // Pricing info dari response (jika ada) - untuk sekarang diabaikan
              // const pricing = response.pricing || {};
              
              // Add Predict ID jika sudah agree
              if (predictFeatureId && agreementsData[predictFeatureId] === 'T') {
                const predictModuleName = this.$global.globalModulNameLink && this.$global.globalModulNameLink.predict && this.$global.globalModulNameLink.predict.name || "Predict ID";
                this.subscriptionModules.push({
                  name: predictModuleName,
                  monthlyFee: 99.00,
                  monthlyAllocation: '50 campaigns',
                  overageEnabled: true,
                  overageRate: 2.50,
                  overageUnit: 'per additional campaign'
                });
              }
              
              // Add Clean ID jika sudah agree
              if (cleanFeatureId && agreementsData[cleanFeatureId] === 'T') {
                this.subscriptionModules.push({
                  name: 'Clean ID',
                  monthlyFee: 199.00,
                  monthlyAllocation: '25,000 contacts',
                  overageEnabled: true,
                  overageRate: 8.00,
                  overageUnit: 'per 1,000 additional contacts'
                });
              }

              // Add Audience ID jika sudah agree
              if (audienceFeatureId && agreementsData[audienceFeatureId] === 'T') {
                this.subscriptionModules.push({
                  name: 'Audience ID',
                  monthlyFee: 149.00,
                  monthlyAllocation: '10,000 contacts',
                  overageEnabled: true,
                  overageRate: 8.00,
                  overageUnit: 'per 1,000 additional contacts'
                });
              }
            }
              
            // Audience ID - di-comment untuk sementara
            // TODO: Uncomment ketika sudah ready untuk audience module
            /*
            const audienceFeatureId = this.$global.betaFeature.audience_module?.id;
            if (audienceFeatureId) {
              const audienceResponse = await this.$store.dispatch('getMarketingServicesAgreementFeature', {
                user_id: userData.id,
                feature_id: audienceFeatureId,
                feature_slug: 'audience_module'
              });
              
              if (audienceResponse.status === 'T') {
                const audiencePricing = audienceResponse.pricing || {};
                this.subscriptionModules.push({
                  name: 'Audience ID',
                  monthlyFee: audiencePricing.monthly_fee || 149.00,
                  monthlyAllocation: audiencePricing.monthly_allocation || '10,000 contacts',
                  overageEnabled: audiencePricing.overage_enabled !== false,
                  overageRate: audiencePricing.overage_rate || 15.00,
                  overageUnit: audiencePricing.overage_unit || 'per 1,000 additional contacts'
                });
              }
            }
            */
            
            // Set overage billing status - true jika ada module dengan overage enabled
            this.overageBillingEnabled = this.subscriptionModules.some(module => module.overageEnabled);
          } catch (error) {
            console.log('Error loading subscription pricing:', error);
            // Fallback ke empty array jika error
            this.subscriptionModules = [];
          }
        }
    },
    computed: {
        showWholesaleCost() {
            const userData = this.$store.getters.userData;
            return !this.$global.systemUser && userData && userData.user_type !== 'client';
        },
        isClient() {
            const userData = this.$store.getters.userData;
            return userData && userData.user_type === 'client';
        },
        hasWeeklyMonthlyFailed() {
            return (this.clientPaymentFailed || this.agencyPaymentFailed) && 
                   this.failedCampaignNumber && 
                   this.failedCampaignNumber.length > 0;
        },
        hasPrepaidFailed() {
            return this.failedPrepaidCampaignIds && 
                   this.failedPrepaidCampaignIds.length > 0;
        }
    },
    watch: {
      agreeTerm: function(value) {
        if (value == true) {
          this.agreeTermStat = false;
        }
      },
    },
    mounted() {
        _sppubkey = this.$global.sppubkey;
        _this = this;
        this.agencyPaymentFailed = this.$global.agencyPaymentFailed;
        this.clientPaymentFailed = this.$global.clientPaymentFailed;
        this.failedCampaignNumber = this.$global.failedCampaignNumber;
        this.failedInvoiceAmount = this.$global.failedInvoiceAmount;
        this.failedPrepaidCampaignIds = this.$global.failedPrepaidCampaignIds;
        
        this.cardfailetoload = false;

        if (typeof(_sppubkey) == "undefined" || _sppubkey == "") {
          this.cardfailetoload = true;
        }else{
          this.initstripelib();
        }
        
        this.getCardInfo();
        this.getStateList();
        this.checkMinSpendLatest();
        
        // Initialize defaultModule (same logic as GeneralSetting.vue)
        const moduleAgency = this.$global.agencyDefaultModules;
        const agencyFilterModules = this.$global.agencyfilteredmodules;
        
        const defaultModule = this.defaultModule.map(module => {
            const agencyModule = moduleAgency && moduleAgency.find(agency => agency.type == module.type);
            if(agencyModule){
                const status = agencyModule.status !== undefined ? agencyModule.status : true;
                return {...module, status: status};
            } else {
                return module;
            }
        });
        
        if(agencyFilterModules){
            const local = agencyFilterModules.local !== undefined ? agencyFilterModules.local.name : '';
            const locator = agencyFilterModules.locator !== undefined ? agencyFilterModules.locator.name : '';
            const enhance = agencyFilterModules.enhance !== undefined ? agencyFilterModules.enhance.name : '';
            const b2b = agencyFilterModules.b2b !== undefined ? agencyFilterModules.b2b.name : '';
            const simplifi = agencyFilterModules.simplifi !== undefined ? agencyFilterModules.simplifi.name : '';
            
            defaultModule[0].name = local;
            defaultModule[1].name = locator;
            defaultModule[2].name = enhance;
            defaultModule[3].name = b2b;
            defaultModule[4].name = simplifi;
        }
        
        this.defaultModule = defaultModule;
        
        // Only call getWholesaleCost if not client
        if (this.showWholesaleCost) {
            this.getWholesaleCost();
        }
        
        // Load subscription pricing data
        this.getSubscriptionPricing();
    },
    beforeDestroy() {
        // Clean up Stripe card element listeners and unmount element
        if (typeof(_cardElement) !== "undefined" && _cardElement) {
            try {
                // Remove change event listener if off method exists
                if (typeof _cardElement.off === 'function' && this.stripeChangeHandler) {
                    _cardElement.off('change', this.stripeChangeHandler);
                }
                // Remove theme-changed window listener
                if (this.stripeThemeHandler) {
                    window.removeEventListener('theme-changed', this.stripeThemeHandler);
                }
                // Unmount the element to clean up all listeners
                _cardElement.unmount();
            } catch (e) {
                // Silently handle errors (element may already be unmounted)
                console.warn('Error cleaning up Stripe element:', e);
            }
        }
    }
}

function initcreditcard() {
  if (!$('#card-element').length) return;

  const activeTheme = localStorage.getItem('user-theme') || 'light-theme';

  const getStyle = (theme) => {
    const isLight = theme === 'light-theme';
    return {
      base: {
        color: isLight ? '#101111' : '#ffffff',
        fontSize: '16px',
        fontFamily: '"Open Sans", sans-serif',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: isLight ? '#8a8a8a' : '#cccccc',
        },
        iconColor: isLight ? '#101111' : '#ffffff',
      },
      invalid: {
        color: '#e5424d',
        iconColor: '#e5424d',
        ':focus': {
          color: isLight ? '#101111' : '#ffffff',
        },
      },
    };
  };

  const style = getStyle(activeTheme);

  _stripe = Stripe(_sppubkey);
  _elements = _stripe.elements();
  _cardElement = _elements.create('card', {
    hidePostalCode: true,
    style,
  });

  _cardElement.mount('#card-element');

  // Store handler references for cleanup
  _this.stripeChangeHandler = (event) => {
    if (event.error) {
      $('#carderror')
        .html(`<small style="color:red"><sup>*</sup>${event.error.message}</small>`)
        .show();
    } else {
      $('#carderror').hide();
    }
  };
  _cardElement.on('change', _this.stripeChangeHandler);

  _this.stripeThemeHandler = (event) => {
    const newTheme = event.detail || localStorage.getItem('user-theme');
    const newStyle = getStyle(newTheme);

    if (_cardElement) {
      try {
        _cardElement.update({ style: newStyle });
      } catch (err) {
         console.warn('⚠️ Update failed, remounting Stripe element', err);
        _cardElement.unmount();
        _cardElement = _elements.create('card', { hidePostalCode: true, style: newStyle });
        _cardElement.mount('#card-element');
        // Re-attach change handler after remount
        if (_this.stripeChangeHandler) {
          _cardElement.on('change', _this.stripeChangeHandler);
        }
      }
    }
  };
  window.addEventListener('theme-changed', _this.stripeThemeHandler);
}
</script>
<style>
/* .select-primary.el-select .el-input input {
  color: rgba(255, 255, 255, 0.8);
} */

#usrccform .card-border {
  width: 95% !important;
  left: 15px;
  line-height: 1.5;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid #525f7f;
  border-radius:4px;
  padding: 8px 12px 6px 12px;
  margin:8px 0px 4px -1px;
  height:36px;
  box-sizing: border-box;
  transform: translateZ(0);
  -webkit-user-select:text;
}

#modaltermofbilling ul li {
  color: #222a42 !important;
}

/* Subscription Pricing Table Styles */
.table-responsive {
  overflow-x: auto;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  padding: 0.75rem;
}

.table tbody td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.table-bordered {
  border: 1px solid #dee2e6;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}

/* Dark mode support for table */
:root.dark-theme .table {
  color: var(--text-primary-color);
}

:root.dark-theme .table thead th {
  border-bottom-color: rgba(255, 255, 255, 0.1);
  color: var(--text-primary-color);
}

:root.dark-theme .table tbody td {
  border-top-color: rgba(255, 255, 255, 0.1);
  color: var(--text-primary-color);
}

:root.dark-theme .table-bordered {
  border-color: rgba(255, 255, 255, 0.1);
}

:root.dark-theme .table-bordered th,
:root.dark-theme .table-bordered td {
  border-color: rgba(255, 255, 255, 0.1);
}

.subscription-terms-note {
  border-top: 1px solid #e0e0e0;
}

:root.dark-theme .subscription-terms-note {
  border-top-color: rgba(255, 255, 255, 0.1);
}

/* Ensure centerform width is applied even when combined with row class */
.row.centerform {
  width: 90% !important;
  margin: 0 auto !important;
}

@media (min-width: 1024px) {
  .row.centerform {
    width: 50% !important;
    margin: 0 auto !important;
  }
}

/* Payment Alert Card Container - Client style: centered with 48% width */
.payment-alert-container--client {
  width: 80%;
  margin: 0 auto 24px auto;
}

@media (min-width: 1024px) {
  .payment-alert-container--client {
    width: 48%;
    margin: 0 auto 24px auto;
  }
}

/* Payment Alert Card Container - Agency style: left aligned with 100% width */
.payment-alert-container--agency {
  width: 100%;
  margin: 0 0 24px 0;
}
/* Payment Alert Card Styles */
.payment-alert-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border-left: 4px solid;
  width: 100%;
  box-sizing: border-box;
}

.payment-alert-card--invoice {
  border-left-color: #ef4444;
  background: linear-gradient(to right, #fee2e2 0%, #ffffff 5%);
}

.payment-alert-card--prepaid {
  border-left-color: #f59e0b;
  background: linear-gradient(to right, #fef3c7 0%, #ffffff 5%);
}

.payment-alert-card__header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: rgba(0, 0, 0, 0.02);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}

.payment-alert-card__header:hover {
  background: rgba(0, 0, 0, 0.04);
}

.payment-alert-card__icon {
  font-size: 20px;
  margin-right: 12px;
  flex-shrink: 0;
}

.payment-alert-card--invoice .payment-alert-card__icon {
  color: #ef4444;
}

.payment-alert-card--prepaid .payment-alert-card__icon {
  color: #f59e0b;
}

.payment-alert-card__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.4;
  flex: 1;
}

.payment-alert-card__chevron {
  font-size: 14px;
  color: #6b7280;
  margin-left: auto;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.payment-alert-card__body {
  padding: 20px;
  transition: all 0.3s ease;
  overflow: hidden;
}

.payment-alert-card__description {
  margin: 0 0 16px 0;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.6;
}

.payment-alert-card__list {
  margin: 16px 0;
  padding: 12px;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.payment-alert-card__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  margin-bottom: 6px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  transition: all 0.2s ease;
  min-height: 36px;
}

.payment-alert-card__item:last-child {
  margin-bottom: 0;
}

.payment-alert-card__item:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-color: #d1d5db;
}

.payment-alert-card__item--prepaid {
  justify-content: flex-start;
  gap: 8px;
}

.payment-alert-card__campaign-label {
  font-weight: 500;
  color: #374151;
  font-size: 14px;
}

.payment-alert-card__campaign-id {
  font-weight: 600;
  color: #1f2937;
  font-size: 14px;
}

.payment-alert-card__campaign-icon {
  color: #6b7280;
  font-size: 14px;
}

.payment-alert-card__amount {
  font-weight: 600;
  color: #dc2626;
  font-size: 14px;
}

.payment-alert-card__total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  margin-top: 12px;
  background: #fee2e2;
  border-radius: 6px;
  border: 1px solid #fecaca;
}

.payment-alert-card__total-label {
  font-weight: 600;
  color: #991b1b;
  font-size: 15px;
}

.payment-alert-card__total-value {
  font-weight: 700;
  color: #dc2626;
  font-size: 18px;
}

.payment-alert-card__message {
  margin: 16px 0 0 0;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.6;
  font-style: italic;
}

@media (max-width: 768px) {
  .payment-alert-card__header {
    padding: 12px 16px;
  }

  .payment-alert-card__body {
    padding: 16px;
  }

  .payment-alert-card__item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .payment-alert-card__total {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

/* Country Select Styling - Match with Client.vue */
.country-region-select-wrapper {
    margin-bottom: 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.country-region-select-wrapper .country-label {
    font-size: .80143rem;
    margin-bottom: 5px;
    display: block;
}

.country-region-select-wrapper .country-region-select {
    background: transparent;
    width: 100%;
    border: none;
    padding: 10px 18px;
    border-radius: 6px;
    border: 1px solid var(--input-border-color);
    outline: none !important;
    color: var(--primary-input-text-color);
}

.country-region-select-wrapper .country-region-select option{
    padding: 10px 18px;
    color: black !important;
}

</style>